<script>
export default {
  name: 'OurSelect',
}
</script>
<template>
  <customer-all-select
    v-bind="$attrs"
    v-on="$listeners"
    :our="true"
  ></customer-all-select>
</template>

<style scoped lang="scss">

</style>


